import api from '@/services/utils/base';

export default class SharedReports {
  post(params:any) {
    return api.post('v1/shared-reports', params)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  put(id, params:any) {
    return api.put(`v1/shared-reports/${id}`, params)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  get() {
    return api.get('v1/shared-reports')
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }

  delete(id) {
    return api.delete(`v1/shared-reports/${id}`)
  }
}
